import { inject, Injectable } from "@angular/core";
import { MCFieldSchema, MC_FIELDS_VALIDATION_NAME, MCFieldTypesService, MCRegex, MCValidation } from "@maslul/common-services";

@Injectable({
    providedIn: 'root'
})
export class FieldsValidationService {

    private fieldTypesService = inject(MCFieldTypesService);


    getAllCustomValidationField(fieldSchema: MCFieldSchema): MCValidation[] {
        const isLinkFormat: boolean = this.isLinkFormat(fieldSchema.pattern);
        if (this.fieldTypesService.isTextInput(fieldSchema.type) && !isLinkFormat) {
            const forbiddenCharsValidation = { name: MC_FIELDS_VALIDATION_NAME.forbiddenChars, params: null } as unknown as MCValidation;
            if (!fieldSchema.validation.find(x => x.name == forbiddenCharsValidation.name)) {
                fieldSchema.validation.push(forbiddenCharsValidation);
            }
        }

        return fieldSchema.validation;
    }

    isLinkFormat(pattern: string): boolean {
        let regexObjectFromString = new RegExp("");
        if (pattern) {
            regexObjectFromString = new RegExp(pattern);
        }
        const areFunctionallyEqual =
            regexObjectFromString.source === MCRegex.linkFormat.source &&
            regexObjectFromString.flags === MCRegex.linkFormat.flags;
        return areFunctionallyEqual;
    }


}

